type SelectableType = HTMLInputElement | HTMLTextAreaElement;

export function selectRange(element: SelectableType, startPosition: number, endPosition: number): void {
  if (typeof element.setSelectionRange === "function") {
    element.focus();
    element.setSelectionRange(startPosition, endPosition);
  }
}

export function placeCursor(element: SelectableType, position: number): void {
  selectRange(element, position, position);
}
